/**
 * Inline 72×24 SVG sparkline — no external chart lib, fits inside a KPI tile.
 *
 * @copyright 2025 Glimbr Pty Ltd
 * @version 2026-04-19-v1
 */
export function Sparkline({
    data,
    width = 72,
    height = 24,
    color = 'currentColor'
}: {
    data: number[];
    width?: number;
    height?: number;
    color?: string;
}) {
    if (data.length === 0) return null;
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const step = width / (data.length - 1);
    const points = data
        .map((v, i) => `${i * step},${height - ((v - min) / range) * height}`)
        .join(' ');
    return (
        <svg
            className="sparkline"
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="none"
            fill="none"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <polyline points={points} />
        </svg>
    );
}
